import { Dropdown } from 'bootstrap/dist/js/bootstrap.bundle.js';

$(function () {
    const desktop = window.matchMedia('(min-width: 992px)');
    const header = document.querySelector('.main-header');
    if (header) {
        const spacer = document.createElement('div');
        spacer.className = 'header-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        header.insertAdjacentElement('afterend', spacer);
        let previousHeight = 0;

        function updateHeaderHeight() {
            if (header.querySelector('.offcanvas-lg.show, .offcanvas-lg.showing, .offcanvas-lg.hiding')) return;
            const height = Math.round(header.getBoundingClientRect().height);
            if (height === previousHeight) return;
            previousHeight = height;
            document.documentElement.style.setProperty('--site-header-height', height + 'px');
        }
        function updateHeaderPosition() {
            header.classList.toggle('is-mobile-fixed', !desktop.matches);
            updateHeaderHeight();
        }
        updateHeaderPosition();
        if ('ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(header);
        else window.addEventListener('resize', updateHeaderHeight);
        if (desktop.addEventListener) desktop.addEventListener('change', updateHeaderPosition);
        else desktop.addListener(updateHeaderPosition);
    }

    $('.main-header .navbar-nav > .menu-item-has-children, .main-header .navbar > .container > .dropdown').each((i, element) => {
        const $item = $(element);
        const trigger = $item.children('[data-bs-toggle="dropdown"]')[0];
        if (!trigger) return;
        const dropdown = Dropdown.getOrCreateInstance(trigger);
        let hideTimeout;
        $item.on('mouseenter', () => {
            clearTimeout(hideTimeout);
            if (desktop.matches) dropdown.show();
        });
        $item.on('mouseleave', () => {
            if (desktop.matches) {
                hideTimeout = setTimeout(() => dropdown.hide(), 150);
            }
        });
    });
});
